import React from 'react'
import MyImage from 'images/hastakshar.svg'

const Hastakshar = props => <img src={MyImage} width="100"/>

export default Hastakshar
